import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"

import InternLinks from "../components/internlinks";
import { FaCheck } from 'react-icons/fa';
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout2>
    <Breadcrumb category={["recensioner", "recensioner"]} page={["Dentway", "dentway"]}/>
     <SEO title="Dentway" description="Recension av Dentway" />
     <section className="section-produkter">
       <article>
       <div className="prod-text">
       <h1>Vitare tänder med Dentway</h1>
         </div>
      </article>
      <article class="right">
        <img src="../tandblekning-dentw.jpg" alt="Dentway Starter Kit"/>
        <aside>
          <h3 class="erbj-pris">495:-</h3><span class="ord-pris">(895:-)</span>
          <h2>Dentway Starter Kit</h2>
          <p>Levereras med 2 stycken formbara tandskenor, blekningsgel 9ml, förvaringsetui för tandskenorna samt en utförlig bruksanvisning. Perfekt för hemmablekning.</p>
          <a href="https://track.adtraction.com/t/t?a=46988996&as=1480987224&t=2&tk=1&url=https://www.dentway.se/sv/artiklar/dentway-starter-kit-regular.html" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
        <ul>
            <li><FaCheck className="li-icon" /> Nöjd-kund-garanti</li>
            <li><FaCheck className="li-icon" /> Fri frakt över 400 kr</li>
            <li><FaCheck className="li-icon" /> Kostnadsfri professionell tandrådgivning</li>
          </ul>
        </aside>
        <div className="prod-text"><h5>Om produkten</h5>
         <p>Tandblekning med Dentway Starter Kit sker i två steg och är relativt enkelt. En bruksanvisning som visar hur du skall gå tillväga för att uppnå önskat resultat när du bleker din tänder hemma.</p></div>
       </article>
       <article>
        <img src="../strips-dentw.jpg" alt="Dentway White Strips"/> 
        <aside>
          <h3>445:-</h3>
          <h2>Dentway White Strips</h2>
          <a href="https://track.adtraction.com/t/t?a=46988996&as=1480987224&t=2&tk=1&url=https://www.dentway.se/sv/artiklar/dentway-whitening-strips.html" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
        <ul>
            <li><FaCheck className="li-icon" /> Ingen risk för ilningar</li>
            <li><FaCheck className="li-icon" /> Nöjd kund garanti</li>
            <li><FaCheck className="li-icon" /> Kostnadsfri professionell tandrådgivning</li>
          </ul>

        </aside>
        <div className="prod-text"><h5>Om produkten</h5>
        <p>En box innehåller 14 X 2 stycken strips, dvs 14 strips för övre tandraden och 14 strips för nedre. Resultat kan ses redan efter en behandling. 
          Bäst resultat uppnås efter daglig behandling under 7 dagar. Ta med den på resor, eller ordna vita tänder snabbt innan festen.</p></div>
      </article>
      <article>
        <div className="prod-text"><h3>Om Dentway</h3>
        <p>Dentway har både skenor och stripes för hemmablekning. Dentway har funnits på marknade sen 2005 så de har många års erfarenhet av
      tandblekningsprodukter för hemmabruk. Dentways egna tandsköterska erbjuder <b>fri tandrådgivning</b> till alla Dentways kunder. Så att få
      information om tandblekning och om det är något du undrar över så har dom bra hjälp. Man har betalning via Klarna på hemsidan vilket är en 
      smidig betalningsmetod. Man har även många andra produkter för tandvård. 
      </p>
      <a href="https://track.adtraction.com/t/t?a=46988996&as=1480987224&t=2&tk=1&url=https://www.dentway.se/sv/artiklar/dentway-whitening-strips.html" target="_blank" rel="noopener noreferrer">Se alla deras produkter här</a>
       
    </div>
      </article>
       </section>
       {/* <section className="section-cards">
    <main>
    <h2 class="rubrik-tandblekning">Bästa tandblekningen hemma</h2>
       <Card />
       </main>
  </section> */}


  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout2>
)

export default IndexPage
